import React, { FunctionComponent } from "react";
import { Theme, makeStyles, Grid, IconButton, useTheme, IconButtonProps } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { darken } from "@mui/material";

interface IQuestionSectionNavButtonStyleProps {
  bgColor: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    height: "100%",
  },
  button: {
    backgroundColor: (props: IQuestionSectionNavButtonStyleProps) => props.bgColor,
    color: theme.palette.common.white,
    borderRadius: 10,
    fontSize: 20,
    fontWeight: 700,
    transition: "background-color 0.2s linear",
    "&:hover": {
      backgroundColor: (props: IQuestionSectionNavButtonStyleProps) => darken(props.bgColor, 0.2),
    },
    "&:disabled": {
      backgroundColor: theme.palette.grey["200"],
    },
    padding: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      padding: theme.spacing(3),
    },
    [theme.breakpoints.up("md")]: {
      padding: theme.spacing(2),
    },
    [theme.breakpoints.up("lg")]: {
      padding: theme.spacing(3),
    },
  },
}));

interface IPresentationNavButtonProps extends IconButtonProps {
  backgroundColor?: string;
}

export const PresentationNavButton: FunctionComponent<IPresentationNavButtonProps> = (props) => {
  const { t } = useTranslation();
  const { children = t("onboarding.next.button"), onClick, backgroundColor, className, ...rest } = props;
  const theme = useTheme();
  const classes = useStyles({ bgColor: backgroundColor ? backgroundColor : theme.palette.primary.main });

  return (
    <Grid container className={classes.container}>
      <IconButton onClick={onClick} className={`${classes.button} ${className}`} disabled={props.disabled} {...rest}>
        {children}
      </IconButton>
    </Grid>
  );
};
